export var OPENING_ORDER_DISCOUNT_COUNTDOWN_MODAL_SEEN = 'OPENING_ORDER_DISCOUNT_COUNTDOWN_MODAL_SEEN';
